<template>
  <div>
    <app-title>Commissions</app-title>
    <v-layout row wrap>
      <v-flex xs6>
        <employee-commissions :employee="employee" :runType="1"
          >Initials</employee-commissions
        >
      </v-flex>
      <v-flex xs6>
        <employee-commissions :employee="employee" :runType="2"
          >Royalty</employee-commissions
        >
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import employeeCommissions from "@/components/commissions/employee-commissions.vue";
import { createNamespacedHelpers } from "vuex";
const { mapState: mapDealerState } = createNamespacedHelpers("dealer");
export default {
  name: "ListCommissions",
  components: {
    employeeCommissions,
  },
  data() {
    return {
      employee: { firstName: "Anna" },
      dealerID: 0,
    };
  },
  computed: {
    ...mapDealerState({
      UBdealerID: (state) => state.dealer.ubDealerID,
    }),
  },
};
</script>

<style scoped>
</style>
